import React from 'react';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { useUserContext } from '../../../context/UserContext';

export const RentalReturnStep5 = ({ onClickDone }) => {
  const { user } = useUserContext();
  const renderButton = () => {
    return (
      <div className={'review-button'}>
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            if (onClickDone) {
              onClickDone();
            }
          }}
        >
          DONE
        </ButtonWithLoadingIcon>
      </div>
    );
  };
  return (
    <div
      style={{
        marginLeft: '2.5rem',
        marginRight: '2.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className={`glyph-icon simple-icon-check`} style={{fontSize: 50}} />
      <span
        style={{ fontFamily: 'Brown Bold', marginBottom: 20, marginTop: 20, color: '#2E2B2B' }}
      >
        Express code:
      </span>
      <span style={{ color: '#2E2B2B', marginBottom: 20 }}>
        Follow the instructions in your email to complete your return.
      </span>
      <span style={{ color: '#7c7571', marginBottom: 15 }}>
        {`A confirmation was sent to ${user?.email?.toLowerCase()}`}
      </span>
      {renderButton()}
    </div>
  );
};
